import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import {
  CssBaseline,
  IconButton,
  LinearProgress,
  Snackbar,
  SnackbarContent
} from '@material-ui/core';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import { Close as CloseIcon } from '@material-ui/icons';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { AlulaTheme as theme, Nav, RouteBreadcrumb } from './layout';
import fetchIntercept from 'fetch-intercept';
import { AuthCookie, UsersApi, SelfApi } from '../api';
import { Home, Library, NotFound, Unauthorized } from './pages';
import { Breadcrumbs } from 'react-breadcrumbs';
import { trim } from 'lodash';

const styles = () => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex'
  },
  content: {
    marginLeft: 0,
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 5,
    paddingTop: theme.spacing.unit * 2.5,
    minWidth: 0, // So the Typography noWrap works
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentShift: {
    marginLeft: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  toolbar: theme.mixins.toolbar,
  error: {
    backgroundColor: theme.palette.error.dark
  }
});

const App = class extends Component {
  state = {
    authUser: null,
    authStateInit: false,
    errorMessage: null,
    menuOpen: false
  };

  componentDidMount = () => {
    this.fetchInterceptListener = fetchIntercept.register({
      response: response => {
        if (response.ok) {
          return response.json();
        }

        return response.text().then(text => {
          let body;
          try {
            body = JSON.parse(text);
          } catch (err) {}

          const message = trim(
            (body && body.error_description ? body.error_description : null) ||
              (body && body.error ? body.error.description : null) ||
              (body && body.error ? body.error.title : null) ||
              text
          );

          const err = {
            status: response.status,
            statusText: response.statusText,
            message: message || response.statusText,
            body
          };

          if (
            response.unauthorized ||
            (response.status === 401 && response.url.includes('token='))
          ) {
            this.logout();
          } else if (response.status !== 401 && err.message) {
            this.showErrorMessage(err);
          }

          return Promise.reject(err);
        });
      },
      responseError: err => {
        this.showErrorMessage(err);
        return Promise.reject(err);
      }
    });

    const { authUser, authStateInit } = this.state;

    if (!authUser && !authStateInit) {
      this.initUser();
    }
  };

  componentWillUnmount = () => {
    this.fetchInterceptListener && this.fetchInterceptListener();
  };

  showErrorMessage = err => {
    this.setState({ errorMessage: err.message });
  };

  closeErrorMessage = () => {
    this.setState({ errorMessage: null });
  };

  toggleDrawer = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  initUser = () => {
    return this.initToken()
      .then(() => SelfApi.get())
      .then(response => UsersApi.get(response.data.id))
      .then(response => {
        this.setState({ authUser: response.data });
        this.setState({ authStateInit: true });
      })
      .catch(err => {
        this.setState({ authStateInit: true });
      });
  };

  logout = () => {
    return this.setState({ authUser: null });
  };

  initToken = () => {
    const token = SelfApi.getQueryStringParam('token');
    // handle page refresh scenario
    // do not initialize token if there is no token param
    if (!token) {
      this.setState({ returnUrl: AuthCookie.getReturnUrl() });
      return Promise.resolve({});
    } else {
      AuthCookie.removeToken();
      return SelfApi.getToken().then(response => {
        this.setState({ returnUrl: `//${response.return_url}` });
        AuthCookie.setReturnUrl(`//${response.return_url}`);
        AuthCookie.setLoginUrl(`//${response.login_url}`);
        return response;
      });
    }
  };

  render = () => {
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          <Fragment>
            <CssBaseline />
            <div className={classes.root}>
              <Nav
                authUser={this.state.authUser}
                menuOpen={this.state.menuOpen}
                returnUrl={this.state.returnUrl}
                toggleDrawer={this.toggleDrawer}
              />
              <main
                className={classNames(classes.content, {
                  [classes.contentShift]: this.state.menuOpen
                })}
              >
                <div className={classes.toolbar} />
                {Boolean(!this.state.authStateInit) && <LinearProgress />}
                {!this.state.authUser &&
                  this.state.authStateInit && <Unauthorized />}
                {this.state.authUser && (
                  <Breadcrumbs>
                    <Switch>
                      <RouteBreadcrumb
                        title="Home"
                        path="/"
                        component={Home}
                        exact
                      />
                      <RouteBreadcrumb
                        title="Library"
                        path="/library"
                        component={Library}
                      />
                      <Route component={NotFound} />
                    </Switch>
                  </Breadcrumbs>
                )}
              </main>
            </div>
            <Snackbar
              open={Boolean(this.state.errorMessage)}
              autoHideDuration={6000}
              onClose={this.closeErrorMessage}
            >
              <SnackbarContent
                className={classes.error}
                message={this.state.errorMessage}
                action={[
                  <IconButton
                    key="close"
                    color="inherit"
                    onClick={this.closeErrorMessage}
                  >
                    <CloseIcon />
                  </IconButton>
                ]}
              />
            </Snackbar>
          </Fragment>
        </Router>
      </MuiThemeProvider>
    );
  };
};

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/components/App.js